import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilterDesc: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFilterDesc"><Path fillRule="evenodd" clipRule="evenodd" d="M3 5H19V6.5H3V5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 11.25H12V12.75H3V11.25Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 17.5H10V19H3V17.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M18.75 10V17.1893L21.25 14.6893L22.3107 15.75L18 20.0607L13.6893 15.75L14.75 14.6893L17.25 17.1893V10H18.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFilterDesc;
